// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__2veoU","LogoBaseline":"Logo_LogoBaseline__3xC2-","LogoSize":"Logo_LogoSize__PtPJs"};